export class StackPrototyp {
  id: number
  tasks: any

  constructor(id: number, tasks: any){
    this.id = id
    this.tasks = tasks
  }
}

export class TaskPrototyp {
  id: number
  method: string
  params: any
  calls: number

  constructor(id: number, method: string, params: Array<any>, calls: number = 0){
    this.id = id
    this.method = method
    this.params = params
    this.calls = calls
  }
}



// WEBPACK FOOTER //
// ./src/providers/odoo/stack.prototyp.ts